// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"fb99fb97","293":"f05ff328","306":"3c682db0","396":"99dc4606","399":"d97e48e3","453":"4c84d9bc"}[chunkId] + ".chunk.js";
};